import { render, staticRenderFns } from "./weeklyList_20260415.vue?vue&type=template&id=56f9070e&scoped=true&"
import script from "./weeklyList_20260415.vue?vue&type=script&lang=js&"
export * from "./weeklyList_20260415.vue?vue&type=script&lang=js&"
import style0 from "./weeklyList_20260415.vue?vue&type=style&index=0&id=56f9070e&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f9070e",
  null
  
)

export default component.exports